export const API_BASE_URL = import.meta.env.MODE === 'production' 
  ? "https://ssw.reinagerona.com" 
  : "http://localhost:8000";
